/**
 * 系统自定义配置
 */

const customization = {
    // crmUrl:"https://sfadev.recloud.com.cn:7500/",
    //crmUrl:"http://10.88.58.25:8881",
    crmUrl:"http://hsdev.hillstonenet.com:8033/",
   // crmUrl:"https://hsdev.hillstonenet.com:8033/",  //  
   // copyright:"Copyright © 2017 苏州瑞泰信息技术有限公司 All Rights Reserved",
    copyright: "Copyright © 2023 山石网科 All Rights Reserved",
    themeColor:""
};

export const copyright = customization.copyright;
export const themeColor = customization.themeColor;
export const crmUrl = customization.crmUrl;

export default customization;


// WEBPACK FOOTER //
// ./src/config/customization.js